export const artistListEl = document.querySelector('.artists-list');
export const artistModalEl = document.querySelector('.modal');
export const backdropWithModalEl = document.querySelector(
  '.backdrop-with-modal'
);
export const artistModalPagesEl = document.querySelector('.artists-pages');
export const genresListEl = document.querySelector('.js-genres-list');

export const header = document.querySelector('.header');

// NEED TO OPTIMIZE
export const filterBtnEl = document.querySelector('.filter-btn');
export const searchFormEl = document.querySelector('.filters');
export const artistsNotFoundEl = document.querySelector('.artists-not-found');
export const resetBtnEl = document.querySelectorAll('.js-reset-btn');

export const modalLoaderEl = document.querySelector('.modal-loader');
export const artistsLoaderEl = document.querySelector('.artists-loader');
export const modalContentEl = document.querySelector('.modal-content');
export const artistsListContentEl = document.querySelector(
  '.artist-list-wrapper'
);

// * feedback modal
export const BASE_URL = 'https://sound-wave.b.goit.study/api';
export const FEEDBACK_PATH = '/feedbacks';
export const feedbackBtnEl = document.querySelector('.js-feedback-btn');
export const feedbackBackdropEl = document.querySelector(
  '.backdrop-feedback-modal'
);
export const feedbackFormEl = document.querySelector('.feedback-modal-form');
export const feedbackCloseBtn = document.querySelector(
  '.js-feedback-modal-close-btn'
);
export const bodyElement = document.body;
export const rating = document.querySelector('[data-raty]');
export const nameErrorEl = feedbackFormEl.querySelector(
  '[data-error-for="name"]'
);
export const messageErrorEl = feedbackFormEl.querySelector(
  '[data-error-for="message"]'
);
export const filtersDropdownWrapperEl = document.querySelector(
  '.filters-dropdown-wrapper'
);
